/* Reway — product page: condition/variant selection + live price + sticky bar */
(function () {
  'use strict';
  function setImageSources(el, src, srcset, sizes, alt) {
    if (!el || !src) return;
    if (srcset) {
      if (sizes && el.getAttribute('sizes') !== sizes) el.setAttribute('sizes', sizes);
      if (!sizes && el.hasAttribute('sizes')) el.removeAttribute('sizes');
      if (el.getAttribute('srcset') !== srcset) el.setAttribute('srcset', srcset);
    } else {
      if (el.hasAttribute('srcset')) el.removeAttribute('srcset');
      if (el.hasAttribute('sizes')) el.removeAttribute('sizes');
    }
    if (el.getAttribute('src') !== src) el.setAttribute('src', src);
    if (typeof alt === 'string' && el.getAttribute('alt') !== alt) el.setAttribute('alt', alt);
  }
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[name="id"]');
      this.uiRoot = this.closest('[data-rw-qs-render], [data-rw-quickshop]') || this.closest('.shopify-section') || this.closest('[data-rw-gallery]') || this;
      this.priceTargets = this.uiRoot.querySelectorAll('[data-rw-price]');
      this.addLabels = this.querySelectorAll('[data-rw-add-price]');
      this.variants = JSON.parse(this.querySelector('[data-rw-variants]').textContent);
      this.addEventListener('change', this.onChange.bind(this));
      /* W8-1 gate (Buyer r2-B1/B2): een ?variant=-deeplink kan een UITVERKOCHTE conditie voorselecteren
         (bv. uit een prijsgefilterde collectie of een gedeelde link): verborgen achter "Toon uitverkochte
         condities", met een actieve CTA die op een 422 een onware voorraadmelding gaf. Vangnet: valt de
         voorselectie op een disabled radio, kies dan de eerste leverbare conditie (zelfde gedrag als
         selected_or_first_available). Geen datamutatie; puur presentatiestaat. */
      var checked = this.querySelector('[data-rw-condition]:checked');
      if (checked && checked.disabled) {
        var firstOk = this.querySelector('[data-rw-condition]:not([disabled])');
        if (firstOk) {
          checked.checked = false;
          firstOk.checked = true;
          firstOk.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    onChange(e) {
      var input = e.target.closest('[data-rw-condition]');
      if (!input || input.closest('product-form') !== this) return;
      var id = parseInt(input.value, 10);
      var variant = this.variants.find(function (v) { return v.id === id; });
      if (!variant) return;
      if (this.idInput) this.idInput.value = variant.id;
      this.querySelectorAll('[data-rw-condition]').forEach(function (r) {
        var card = r.closest('.rw-cond, .rw-condr');
        if (card) card.classList.toggle('is-selected', r.checked);
      });
      var money = window.RewayMoney ? window.RewayMoney(variant.price) : (variant.price / 100).toFixed(2);
      this.priceTargets.forEach(function (el) { el.textContent = money; });
      this.addLabels.forEach(function (el) { el.textContent = money; });
      // doorstreepte 'van'-prijs meebewegen (of verbergen) per variant
      var cmp = variant.compare && variant.compare > variant.price ? (window.RewayMoney ? window.RewayMoney(variant.compare) : (variant.compare / 100).toFixed(2)) : null;
      this.uiRoot.querySelectorAll('[data-rw-compare]').forEach(function (el) {
        if (cmp) { el.textContent = cmp; el.hidden = false; } else { el.hidden = true; }
      });
      var stickyVar = this.uiRoot.querySelector('[data-rw-sticky-variant]');
      if (stickyVar && variant.title) stickyVar.textContent = variant.title;
      /* W8-2 gate (E-com B1, pre-existent): de sticky-bar-CTA bleef op de OUDE variant-id staan na een
         conditie-wissel — bar toonde de nieuwe prijs maar voegde de oude variant toe. De bar blijft
         [data-rw-add=<variantId>] gebruiken (contract A3); alleen de waarde volgt nu de selectie. */
      this.uiRoot.querySelectorAll('.rw-stickybar [data-rw-add]').forEach(function (b) {
        b.setAttribute('data-rw-add', variant.id);
        b.disabled = !variant.available;
      });
      // stock state + keep the add button pointing at the selected variant (quick-shop uses data-rw-add)
      var addBtn = this.querySelector('[data-rw-addbtn]');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.classList.toggle('is-disabled', !variant.available);
        if (addBtn.hasAttribute('data-rw-add')) addBtn.setAttribute('data-rw-add', variant.id);
      }
      // voorraad-indicator: exact aantal tonen bij minder dan 3 op voorraad
      var stockEl = this.uiRoot.querySelector('[data-rw-stock]');
      var stockText = this.uiRoot.querySelector('[data-rw-stock-text]');
      if (stockEl && stockText) {
        if (!variant.available) {
          stockEl.classList.add('is-out');
          stockText.textContent = stockEl.getAttribute('data-soldout') || 'Uitverkocht';
        } else {
          stockEl.classList.remove('is-out');
          if (variant.inv != null && variant.inv > 0 && variant.inv < 3) {
            stockText.textContent = 'Nog ' + variant.inv + (variant.inv === 1 ? ' op voorraad' : ' op voorraad');
          } else {
            stockText.textContent = stockEl.getAttribute('data-instock') || 'Op voorraad';
          }
        }
      }
      this.swapImage(variant);
    }
    swapImage(variant) {
      // toon de aan deze variant gekoppelde foto; val terug op de product-cover
      var defImg = this.getAttribute('data-rw-default-img');
      var defMedia = this.getAttribute('data-rw-default-media');
      var img = variant.img || defImg;
      var srcset = variant.img ? variant.srcset : this.getAttribute('data-rw-default-srcset');
      var sizes = variant.img ? variant.sizes : this.getAttribute('data-rw-default-sizes');
      var alt = variant.img ? variant.alt : this.getAttribute('data-rw-default-alt');
      var mediaId = (variant.media != null) ? String(variant.media) : (defMedia || '');
      // hoofdafbeelding (PDP-gallery en quick-shop)
      var gallery = this.closest('[data-rw-gallery]');
      var quickShop = this.closest('[data-rw-qs-render]') || this.closest('[data-rw-quickshop]');
      if (gallery) setImageSources(gallery.querySelector('[data-rw-gallery-main] img'), img, srcset, sizes, alt);
      if (quickShop) setImageSources(quickShop.querySelector('.rw-qs__media img'), img, srcset, sizes, alt);
      // PDP-thumbnails: heeft de variant een eigen foto -> toon ALLEEN die; anders alle foto's
      if (gallery) {
        var hasVariantImg = (variant.media != null);
        var visible = 0;
        gallery.querySelectorAll('[data-rw-thumb]').forEach(function (t) {
          var mid = t.getAttribute('data-rw-media-id');
          var show = hasVariantImg ? (mid === mediaId) : true;
          t.hidden = !show;
          t.classList.toggle('is-active', mid === mediaId);
          if (mid === mediaId) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); } /* W8-2 gate A11y-r3 B1: aria-current volgt de actieve thumb */
          if (show) visible++;
        });
        var thumbsWrap = gallery.querySelector('.rw-pdp__thumbs');
        if (thumbsWrap) thumbsWrap.hidden = (visible <= 1);   // verberg de strip als er maar één foto over is
      }
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  // Toggle sold-out conditions onder de "Toon/Verberg uitverkochte"-knop (in- en uitklapbaar)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rw-show-soldout]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('product-form, .rw-pdp__form, .rw-qs__form') || document;
    var list = scope.querySelector('[data-rw-soldout-list]');
    if (!list) return;
    var open = list.hidden;            // wordt nu geopend?
    list.hidden = !open;
    btn.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var show = btn.querySelector('[data-rw-soldout-show]');
    var hide = btn.querySelector('[data-rw-soldout-hide]');
    if (show && hide) { show.hidden = open; hide.hidden = !open; }
  });

  // Condition info (i) toggle — shows/hides the dark explanation box
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rw-cond-info-toggle]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('product-form, .rw-pdp__form, .rw-qs__form, .rw-pdp__info') || document;
    var box = scope.querySelector('[data-rw-cond-info]');
    if (!box) return;
    var show = box.hasAttribute('hidden');
    if (show) { box.removeAttribute('hidden'); } else { box.setAttribute('hidden', ''); }
    btn.setAttribute('aria-expanded', show ? 'true' : 'false');
  });

  // money helper shared
  window.RewayMoney = function (cents) {
    try {
      var cur = (window.theme && window.theme.settings && window.theme.settings.currency) || 'EUR';
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cur }).format(cents / 100).replace(/\s/g, ''); /* W5-4 gate: geen spatie na het valutateken - gelijk aan de Liquid-money-render */
    } catch (e) { return '€' + (cents / 100).toFixed(2); }
  };

  // gallery thumbnails
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-rw-thumb]');
    if (!thumb) return;
    var gal = thumb.closest('[data-rw-gallery]');
    if (!gal) return;
    var main = gal.querySelector('[data-rw-gallery-main] img');
    var full = thumb.getAttribute('data-rw-thumb');
    setImageSources(main, full, thumb.getAttribute('data-rw-thumb-srcset'), thumb.getAttribute('data-rw-thumb-sizes'), thumb.getAttribute('data-rw-thumb-alt'));
    gal.querySelectorAll('[data-rw-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
      if (t === thumb) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); } /* W8-2 gate A11y-r3 B1 */
    });
  });

  // sticky add-to-cart bar: verschijnt direct zodra de koopknop uit beeld is (frame-perfecte scroll-check)
  var bar = document.querySelector('[data-rw-stickybar]');
  /* W10-1c gate r5 (Mobile B1): body-padding = werkelijke balkhoogte (67px, 2-regelige conditie 73,5, incl. safe-area) —
     een vaste waarde liet een lichte strook tussen footer en balk staan */
  if (bar && 'ResizeObserver' in window) {
    var sbhRO = new ResizeObserver(function () {
      var h = Math.ceil(bar.getBoundingClientRect().height);
      if (h > 0) document.body.style.setProperty('--rw-sbh', h + 'px');
    });
    sbhRO.observe(bar);
  }
  var anchor = document.querySelector('[data-rw-addbtn]') || document.querySelector('[data-rw-cta-anchor]');
  if (bar && anchor) {
    var sTicking = false;
    function headerOffset() {
      var f = document.querySelector('.rw-hdr__fixed');
      if (f) { var rr = f.getBoundingClientRect(); if (rr.height > 0 && rr.top <= 1) return rr.bottom; }
      var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--rw-header-h'), 10);
      return v > 0 ? v : 0;
    }
    function updateSticky() {
      sTicking = false;
      var r = anchor.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // W10-1c (Principal W10-1a r5 t7): de balk verdween al toen de knop nog maar deels zichtbaar was —
      // hij blijft nu tot de hoofd-CTA volledig in beeld is (24px coulance aan de headerkant)
      var inView = r.top >= headerOffset() - 24 && r.bottom <= vh;
      bar.classList.toggle('is-visible', !inView);
    }
    function onScrollSticky() { if (!sTicking) { sTicking = true; requestAnimationFrame(updateSticky); } }
    window.addEventListener('scroll', onScrollSticky, { passive: true });
    window.addEventListener('resize', onScrollSticky, { passive: true });
    updateSticky();
  }
})();
